module.exports = __webpack_public_path__ + "img/shuhe.2c95d452.png";